import * as React from 'react'
import PowerSelect from '../../Form/PowerSelect'
import styled from 'styled-components'
import { Style } from '../../../styles'
import ActionButton from '../ActionButton'
import Icon from '../../Icons/Icon'
import { WithTranslation, withTranslation } from 'react-i18next'
import ReactSelectTheme from '../../Form/ReactSelectTheme'
import { MailchimpFormData, MailchimpIntegrationConfig } from '../../../types'

type IProps = {
  config: MailchimpIntegrationConfig
  formData: MailchimpFormData
  onConfigChange: (config: MailchimpIntegrationConfig) => void
} & WithTranslation

interface IState { }

const Container = styled.div`
	display: flex;
	flex-direction: column;

	h1 {
		color: white;
		margin-bottom: ${Style.spacing.x2};
    font-weight: bold;
	}
	
	label {
		color: white;
	}
`

class MailchimpForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    this.onAudienceChange = this.onAudienceChange.bind(this)
  }

  onAudienceChange(option) {
    const { config, onConfigChange } = this.props

    onConfigChange({
      ...config,
      audience_id: option.value,
    })
  }

  render() {
    const { config, formData, t } = this.props
    const { audiences } = formData

    const audienceOptions = audiences
    const selectedProfileOption = audiences.find(p => p.value === config.audience_id)

    return (
      <Container>
        <h1 style={{ color: 'black' }}>{t('MailchimpForm::Settings')}</h1>
        <div className='form-item'>
          <label style={{ color: 'black' }}>
            {t('MailchimpForm::Choose the mailchimp list where you want {{__appName}} to synchronize to.')}
          </label>
          <PowerSelect
            options={audienceOptions}
            value={selectedProfileOption}
            onChange={this.onAudienceChange}
            theme={ReactSelectTheme}
          />
        </div>
      </Container>
    )
  }
}

export default withTranslation()(MailchimpForm)